import React from "react";

const Policy = () => {
  return (
    <section className="tw-py-16 tw-bg-slate-50/50 tw-border-t tw-border-solid tw-border-slate-100">
      <div className="tw-max-w-4xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        <div className="tw-bg-white tw-shadow-md tw-rounded-3xl tw-border tw-border-solid tw-border-slate-100 tw-p-8 sm:tw-p-12 tw-text-left">
          
          {/* Card Header */}
          <div className="tw-flex tw-flex-col sm:tw-flex-row sm:tw-justify-between sm:tw-items-center tw-gap-4 tw-border-b tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-solid tw-border-slate-100 tw-pb-6 tw-mb-8">
            <h2 className="tw-text-xl tw-font-extrabold tw-text-slate-800">
              BeyondLeadz Privacy Policy
            </h2>
            <div>
              <span className="tw-inline-flex tw-items-center tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-semibold tw-bg-indigo-50 tw-text-[#5D44FF] tw-border tw-border-solid tw-border-indigo-100">
                Effective Date: April 7, 2025
              </span>
            </div>
          </div>

          {/* Intro */}
          <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-6">
            At <strong className="tw-font-bold tw-text-slate-800">BeyondLeadz</strong> (“we,” “our,” or “us”), we are committed to safeguarding your privacy and the confidentiality of your business data. This Privacy Policy explains how we collect, use, and protect the information you provide when using our website, platform, and related services (collectively, the “Services”).
          </p>
          <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-8">
            By using BeyondLeadz, you agree to the terms of this policy.
          </p>

          {/* Section 1 */}
          <h3 className="tw-text-lg tw-font-bold tw-text-slate-900 tw-mt-8 tw-mb-4 tw-flex tw-items-center tw-gap-2">
            <span className="tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-rounded-lg tw-bg-indigo-50 tw-text-xs tw-text-[#5D44FF] tw-font-bold">1</span>
            Information We Collect
          </h3>
          <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-6">
            We collect information that you voluntarily provide, including your name, email, phone number, company details, lead and campaign data, and billing information. This information is collected when you create an account, use the platform, contact support, or participate in a trial or promotion.
          </p>
          <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-6 tw-bg-slate-50 tw-border tw-border-solid tw-border-slate-100 tw-rounded-2xl tw-p-5">
            <strong className="tw-font-semibold tw-text-slate-800">Please note:</strong> BeyondLeadz does not use cookies or tracking tools to collect personal or technical information for marketing or profiling purposes. Any system-level logs (e.g., IP addresses) used for platform security or diagnostics are not linked to individual users.
          </p>

          {/* Section 2 */}
          <h3 className="tw-text-lg tw-font-bold tw-text-slate-900 tw-mt-8 tw-mb-4 tw-flex tw-items-center tw-gap-2">
            <span className="tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-rounded-lg tw-bg-indigo-50 tw-text-xs tw-text-[#5D44FF] tw-font-bold">2</span>
            How Your Information Is Used
          </h3>
          <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-4">
            The information you provide is used to:
          </p>
          <ul className="tw-space-y-3.5 tw-pl-0 tw-mb-6">
            <li className="tw-flex tw-items-start tw-gap-3 tw-text-base tw-text-slate-600">
              <span className="tw-inline-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-rounded-full tw-bg-indigo-50 tw-text-[#5D44FF] tw-text-xs tw-font-bold tw-mt-0.5 tw-flex-shrink-0">1</span>
              <span>Operate and manage your BeyondLeadz account</span>
            </li>
            <li className="tw-flex tw-items-start tw-gap-3 tw-text-base tw-text-slate-600">
              <span className="tw-inline-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-rounded-full tw-bg-indigo-50 tw-text-[#5D44FF] tw-text-xs tw-font-bold tw-mt-0.5 tw-flex-shrink-0">2</span>
              <span>Deliver the platform’s features and functionality</span>
            </li>
            <li className="tw-flex tw-items-start tw-gap-3 tw-text-base tw-text-slate-600">
              <span className="tw-inline-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-rounded-full tw-bg-indigo-50 tw-text-[#5D44FF] tw-text-xs tw-font-bold tw-mt-0.5 tw-flex-shrink-0">3</span>
              <span>Provide customer support and respond to inquiries</span>
            </li>
            <li className="tw-flex tw-items-start tw-gap-3 tw-text-base tw-text-slate-600">
              <span className="tw-inline-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-rounded-full tw-bg-indigo-50 tw-text-[#5D44FF] tw-text-xs tw-font-bold tw-mt-0.5 tw-flex-shrink-0">4</span>
              <span>Process payments for paid services</span>
            </li>
            <li className="tw-flex tw-items-start tw-gap-3 tw-text-base tw-text-slate-600">
              <span className="tw-inline-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-rounded-full tw-bg-indigo-50 tw-text-[#5D44FF] tw-text-xs tw-font-bold tw-mt-0.5 tw-flex-shrink-0">5</span>
              <span>Share updates or service-related notifications</span>
            </li>
          </ul>
          <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-6">
            All customer data, including lead or contact lists, is encrypted and inaccessible to us — therefore, it cannot be used for marketing, resale, or any form of repurposing.
          </p>

          {/* Section 3 */}
          <h3 className="tw-text-lg tw-font-bold tw-text-slate-900 tw-mt-8 tw-mb-4 tw-flex tw-items-center tw-gap-2">
            <span className="tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-rounded-lg tw-bg-indigo-50 tw-text-xs tw-text-[#5D44FF] tw-font-bold">3</span>
            Data Sharing
          </h3>
          <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-4">
            We do not sell or share your personal or customer-identifiable data.
          </p>
          <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-4">
            We may share limited, non-personal information with trusted service providers (e.g., cloud infrastructure or billing partners) strictly for operational purposes. These providers receive only what is required to perform their services and are bound by confidentiality and data protection agreements.
          </p>
          <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-6">
            We do not share lead data, customer contact details, or campaign content with any third party.
          </p>

          {/* Section 4 */}
          <h3 className="tw-text-lg tw-font-bold tw-text-slate-900 tw-mt-8 tw-mb-4 tw-flex tw-items-center tw-gap-2">
            <span className="tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-rounded-lg tw-bg-indigo-50 tw-text-xs tw-text-[#5D44FF] tw-font-bold">4</span>
            Data Retention
          </h3>
          <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-6">
            We retain your data only as long as necessary to provide our services and meet legal, contractual, or operational requirements. You may request deletion of your data at any time by contacting us.
          </p>

          {/* Section 5 */}
          <h3 className="tw-text-lg tw-font-bold tw-text-slate-900 tw-mt-8 tw-mb-4 tw-flex tw-items-center tw-gap-2">
            <span className="tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-rounded-lg tw-bg-indigo-50 tw-text-xs tw-text-[#5D44FF] tw-font-bold">5</span>
            Your Privacy Rights
          </h3>
          <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-6">
            Depending on your jurisdiction, you may have the right to access, update, delete, or request a copy of your personal data. You may also withdraw consent or object to certain types of data processing.
          </p>
          <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-6">
            To make a privacy request, please contact us at:{" "}
            <a
              href="mailto:contact@beyondleadz.ai"
              className="tw-text-[#5D44FF] hover:tw-underline tw-font-medium tw-transition-colors"
            >
              contact@beyondleadz.ai
            </a>
          </p>

          {/* Section 6 */}
          <h3 className="tw-text-lg tw-font-bold tw-text-slate-900 tw-mt-8 tw-mb-4 tw-flex tw-items-center tw-gap-2">
            <span className="tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-rounded-lg tw-bg-indigo-50 tw-text-xs tw-text-[#5D44FF] tw-font-bold">6</span>
            Data Security
          </h3>
          <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-6">
            We use industry-standard security practices to protect your data, including encryption, secure access controls, and regular infrastructure audits. Your data is stored and processed in secure environments to prevent unauthorized access or misuse.
          </p>

          {/* Section 7 */}
          <h3 className="tw-text-lg tw-font-bold tw-text-slate-900 tw-mt-8 tw-mb-4 tw-flex tw-items-center tw-gap-2">
            <span className="tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-rounded-lg tw-bg-indigo-50 tw-text-xs tw-text-[#5D44FF] tw-font-bold">7</span>
            International Use
          </h3>
          <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-6">
            BeyondLeadz may be accessed globally. By using our services, you consent to the transfer and processing of your data in countries where our platform and partners operate, in compliance with applicable laws.
          </p>

          {/* Section 8 */}
          <h3 className="tw-text-lg tw-font-bold tw-text-slate-900 tw-mt-8 tw-mb-4 tw-flex tw-items-center tw-gap-2">
            <span className="tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-rounded-lg tw-bg-indigo-50 tw-text-xs tw-text-[#5D44FF] tw-font-bold">8</span>
            Children’s Privacy
          </h3>
          <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-6">
            BeyondLeadz is a business-to-business (B2B) service and not intended for individuals under the age of 18. We do not knowingly collect or store personal information from children.
          </p>

          {/* Section 9 */}
          <h3 className="tw-text-lg tw-font-bold tw-text-slate-900 tw-mt-8 tw-mb-4 tw-flex tw-items-center tw-gap-2">
            <span className="tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-rounded-lg tw-bg-indigo-50 tw-text-xs tw-text-[#5D44FF] tw-font-bold">9</span>
            Policy Updates
          </h3>
          <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-6">
            We may update this Privacy Policy from time to time. If we make significant changes, we will notify you via the platform or email. Continued use of the Services constitutes your acceptance of the revised policy.
          </p>

          {/* Section 10 */}
          <h3 className="tw-text-lg tw-font-bold tw-text-slate-900 tw-mt-8 tw-mb-4 tw-flex tw-items-center tw-gap-2">
            <span className="tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-rounded-lg tw-bg-indigo-50 tw-text-xs tw-text-[#5D44FF] tw-font-bold">10</span>
            Contact Us
          </h3>
          <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-4">
            If you have any questions or concerns about this Privacy Policy, or if you’d like to make a data-related request, please contact:
          </p>
          <div className="tw-bg-slate-50 tw-border tw-border-solid tw-border-slate-100 tw-rounded-2xl tw-p-5">
            <p className="tw-text-base tw-text-slate-800 tw-font-semibold tw-mb-1">BeyondLeadz</p>
            <p className="tw-text-base tw-text-slate-600 tw-m-0">
              Email:{" "}
              <a
                href="mailto:contact@beyondleadz.ai"
                className="tw-text-[#5D44FF] hover:tw-underline tw-font-medium tw-transition-colors"
              >
                contact@beyondleadz.ai
              </a>
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Policy;

